// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"TU-z","inlineTitle":"UU-z","sponsoredAdsWrapper":"VU-z","marketplaceRecosWrapper":"WU-z"};